export default __webpack_public_path__ + "static/media/keto_breakfast_time@2x.232866ea.jpg";